/* ─────────────────────────────────────────────────────────────
   Medicore product card behaviour

   Adds single-variant products to the cart from any listing without
   a page load. Bound once at the document, not per section, because
   the card now appears in grids that are re-rendered by filtering
   and pagination - a per-section listener would go missing the
   moment the collection grid was swapped out.

   The forms post to /cart/add normally if this never runs, so the
   card degrades to a full page load rather than to a dead button.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (document.documentElement.dataset.mcCardBound === 'true') return;
  document.documentElement.dataset.mcCardBound = 'true';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.mc-card__form');
    if (!form) return;

    event.preventDefault();
    if (form.classList.contains('is-busy')) return;

    var id = form.querySelector('[name="id"]');
    if (!id) {
      form.submit();
      return;
    }

    form.classList.add('is-busy');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id.value, quantity: 1 }] })
    })
      .then(function (response) {
        form.classList.remove('is-busy');
        if (!response.ok) {
          // Out of stock since the page rendered, or a quantity rule.
          // The product page states the reason properly.
          var button = form.querySelector('.mc-card__btn');
          window.location.href = (button && button.dataset.url) || form.action;
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:added'));
        if (window.CartDrawer) window.CartDrawer.open();
      })
      .catch(function () {
        form.classList.remove('is-busy');
        form.submit();
      });
  });
})();
